export default __webpack_public_path__ + "static/media/network1.0710706d.svg";